import { Tabs, Tab, Divider, Badge } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { IncomingBankPaymentStatusEnum } from 'src/shared/models/enums/incomingBankPaymentStatus.enum';

interface IncomingBankPaymentPageTabsProps {
  initialValue: IncomingBankPaymentStatusEnum;
  disableAll: boolean;
  callback: (status: IncomingBankPaymentStatusEnum) => void;
  unmatchedCount?: number;
}
interface TabItem {
  label: string;
  status: IncomingBankPaymentStatusEnum;
  badgeCount?: number;
}

export const IncomingBankPaymentPageTabs = ({ initialValue, disableAll, callback, unmatchedCount }: IncomingBankPaymentPageTabsProps) => {
  const [value, setValue] = React.useState<IncomingBankPaymentStatusEnum>(initialValue);

  const { t } = useTranslation(['invoice']);

  const handleChange = (event: React.ChangeEvent<any>, newValue: IncomingBankPaymentStatusEnum) => {
    ConsoleHelper.log('newvalue', newValue);
    setValue(newValue);
    callback(newValue);
  };

  const tabItems: TabItem[] = [
    {
      label: t('invoice:incomingBankPayment.tabs.unMatched'),
      status: IncomingBankPaymentStatusEnum.UnMatched,
      badgeCount: unmatchedCount,
    },
    {
      label: t('invoice:incomingBankPayment.tabs.matched'),
      status: IncomingBankPaymentStatusEnum.Matched,
    },
  ];

  return (
    <>
      <Tabs
        value={value}
        textColor='primary'
        onChange={handleChange}
        sx={{
          '& button': {
            textTransform: 'none',
          },
          '& .hasBadge': {
            pr: '2rem',
            '& .MuiBadge-badge': {
              right: '-10px',
              top: '-2px',
            },
          },
        }}
      >
        {tabItems.map((item) => (
          <Tab
            key={item.label}
            label={
              item.badgeCount ? (
                <Badge
                  badgeContent={item.badgeCount}
                  color='error'
                  sx={{
                    '& .MuiBadge-badge': {
                      top: 0,
                      right: -18,
                      transform: 'translateY(-50%) scale(1)',
                      minWidth: 16,
                      height: 16,
                      fontSize: '0.65rem',
                      padding: '0 4px',
                    },
                  }}
                >
                  {item.label}
                </Badge>
              ) : (
                item.label
              )
            }
            sx={item.badgeCount ? { pr: 4 } : undefined}
            value={item.status}
            disabled={disableAll}
          />
        ))}
      </Tabs>
      <Divider />
    </>
  );
};
